// src/components/SearchWithAiButton/SearchWithAiButton.jsx

import React from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Button from "@mui/material/Button";
import styles from "./SearchWithAiButton.module.css";
import NobiEventTracker from "../../utils/NobiEventTracker";
import Events from "../../utils/Events";

/**
 * SearchWithAiButton component, a simple button that calls up our drawer
 *
 * @param merchantId The merchant ID
 * @param brandTheme A dictionary of brand theme attributes
 * @param onClick The function to call when the button is clicked
 * @param isSubmitForForm A boolean to determine if the button is a submit button for a form
 * @param buttonLabel The label for the button
 * @constructor
 */
const SearchWithAiButton = ({merchantId, brandTheme, onClick, isSubmitForForm, buttonLabel}) => {
    return <Button
        type={isSubmitForForm ? "submit" : "button"}
        onClick={() => {
            NobiEventTracker.trackEvent(merchantId, null, Events.ClickSearchWithAiButton, false, null, null, null);
            if (onClick) {
                onClick();
            }
        }}
        aria-label="Search With AI"
        startIcon={<AutoAwesomeIcon />}
        className={styles.aiButton}
        sx={{
            backgroundColor: brandTheme?.general?.buttons?.backgroundColor,
            color: brandTheme?.general?.buttons?.textColor,
            '&:hover': {
                backgroundColor: brandTheme?.general?.buttons?.hoverColor,
            },
            fontFamily: brandTheme?.general?.buttons?.fontFamily || "inherit",
        }}
    >
        {buttonLabel || "Search With AI"}
    </Button>
};

export default SearchWithAiButton;